import { addDays, format } from "date-fns";
import { excelDateToJSDate } from "../../../utils/helpers/files/exceldatetojs";
import { getAllSpeakers } from "../../../utils/services/speaker";
import { getSchedule } from "../../../utils/services/schedule";

export const excelColumnsPtBr = {
  Titulo: "title",
  Descricao: "description",
  DataDaProgramacao: "startDate",
  HoraInicio: "startHour",
  HoraFim: "endHour",
  Foto: "picture",
  TipoOuLocalDaProgramacao: "typeOrLocation",
  CorDaProgramacao: "color",
  Palestrantes: "palestrantes",
  Grupos: "groups",
};

export const excelColumnsUpdatePtBr = {
  AgendaID: "id",
  Titulo: "title",
  Descricao: "description",
  DataDaProgramacao: "startDate",
  HoraInicio: "startHour",
  HoraFim: "endHour",
  Foto: "picture",
  TipoOuLocalDaProgramacao: "typeOrLocation",
  CorDaProgramacao: "color",
  Palestrantes: "palestrantes",
  Grupos: "groups",
};

export const excelColumnsDeletePtBr = {
  AgendaID: "id",
  Titulo: "title",
};

function formatDate(date) {
  try {
    return format(addDays(new Date(date), 1), "MM-dd-yyyy");
  } catch (error) {
    return undefined;
  }
}

function formatTime(time) {
  try {
    return format(excelDateToJSDate(time), "HH:mm");
  } catch (error) {
    return undefined;
  }
}

export function allExcelColumns(row, index, eventId) {
  const formatedRow = {
    index,
    startDate: formatDate(row.startDate),
    startHour: row.startHour ? formatTime(row.startHour) : "",
    endHour: row.endHour ? formatTime(row.endHour) : "",
    title: row.title ? row.title : undefined,
    order: row.order ?? "",
    description: row.description ? row.description : "",
    typeOrLocation: row.typeOrLocation ? row.typeOrLocation : "",
    color: row.color ? row.color : "",
    picture: row.picture ? row.picture : "",
    picture2: row.picture2 ? row.picture2 : "",
    picture3: row.picture3 ? row.picture3 : "",
    picture4: row.picture4 ? row.picture4 : "",
    picture5: row.picture5 ? row.picture5 : "",
    expireDate: !row.picture ? null : "2035-12-31T23:59:32.112Z",
    palestrantes:
      typeof row.palestrantes === "string" && row.palestrantes.trim() !== ""
        ? row.palestrantes
            .split(",")
            .map((p) => p.trim())
            .filter(Boolean)
        : [],
    groups: row.groups ? row.groups.split(",") : "",
  };

  return formatedRow;
}

export function allExcelColumnsUpdate(row, index, eventId) {
  const formatedRow = {
    index,
    id: row.id ? row.id : undefined,
    startDate: formatDate(row.startDate),
    startHour: row.startHour ? formatTime(row.startHour) : "",
    endHour: row.endHour ? formatTime(row.endHour) : "",
    title: row.title ? row.title : undefined,
    order: row.order ?? "",
    description: row.description ? row.description : "",
    typeOrLocation: row.typeOrLocation ? row.typeOrLocation : "",
    color: row.color ? row.color : "",
    picture: row.picture ? row.picture : "",
    picture2: row.picture2 ? row.picture2 : "",
    picture3: row.picture3 ? row.picture3 : "",
    picture4: row.picture4 ? row.picture4 : "",
    picture5: row.picture5 ? row.picture5 : "",
    expireDate: !row.picture ? null : "2035-12-31T23:59:32.112Z",
    palestrantes:
      typeof row.palestrantes === "string" && row.palestrantes.trim() !== ""
        ? row.palestrantes
            .split(",")
            .map((p) => p.trim())
            .filter(Boolean)
        : [],
    groups: row.groups ? row.groups.split(",") : "",
  };

  return formatedRow;
}

export function allExcelColumnsDelete(row, index) {
  const formatedRow = {
    index,
    id: row.id ? row.id : undefined,
    title: row.title ? row.title : undefined,
  };

  return formatedRow;
}

function hasValidProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

export async function getValidateAgenda(file, eventId, importType) {
  const limit = 9999;

  const getSpeakers = await getAllSpeakers(eventId, 1, limit, "", "");
  const speakersIds = getSpeakers?.data?.findAllPalestrantes?.data?.map(
    (e) => e.id,
  );

  const getAgendas = await getSchedule({
    id: eventId,
    jwt: "",
    offset: 1,
    limit: limit,
    search: "",
  });

  const agendasIds = getAgendas?.agenda?.data?.map((e) => e.id);

  const erros = [];

  file.forEach((item, index) => {
    const error = { index };

    if (!item.title || item.title.trim() === "") {
      error.title = undefined;
    }
    if (importType !== "delete") {
      if (!formatDate(item.startDate) || item.startDate.trim() === "") {
        error.startDate = undefined;
      }
    }

    if (importType !== "create") {
      const agendaId = item?.id;

      if (typeof agendaId !== "string" || agendaId.trim() === "") {
        error.id = undefined;
        error.invalidId = null;
      } else {
        const invalidId = !agendasIds.includes(agendaId);

        if (invalidId) {
          error.id = undefined;
          error.invalidId = agendaId;
        }
      }
    }
    const speakersStr = item.palestrantes;

    if (importType !== "delete") {
      if (speakersStr.lenght < 1) {
        // error.agendas = undefined;
      } else {
        const ids = speakersStr.map((id) => id.trim());
        const invalidIds = ids.filter((id) => !speakersIds.includes(id));

        if (invalidIds.length > 0) {
          error.palestrantes = undefined;
          error.invalidPalestrantes = invalidIds;
        }
      }
    }
    if (
      (hasValidProperty(error, "title") && error.title === undefined) ||
      (hasValidProperty(error, "startDate") && error.startDate === undefined) ||
      (hasValidProperty(error, "palestrantes") &&
        error.palestrantes === undefined) ||
      (hasValidProperty(error, "id") && error.id === undefined)
    ) {
      erros.push(error);
    }
  });

  return erros;
}
